import gql from 'graphql-tag';

import ProductDataFragment from './ProductData.js';

export default gql`
  fragment ProductEmbedItemFragment on ProductEmbedItem {
    id
    type
    data {
      titleHtml
      product {
        ...ProductDataFragment
      }
    }
  }
  ${ProductDataFragment}
`;
